import { Route, Switch } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import useViewer from 'packages/kakapo-ui-application/hooks/useViewer';

import EvaluationSubmissionRequestModal, {
	EvaluationSubmissionRequestModalMoment,
} from 'packages/kakapo-ui-application/pages/evaluation-submissions/EvaluationSubmissionRequestModal';
import CycleMomentSelectorModal from 'packages/kakapo-ui-kit/components/cycles/CycleMomentSelectorModal';
import CreateConversationModal from 'conversations/CreateConversationModal';

type RouteProps = {
	userID: string;
	momentID: string;
};

export default function ConversationsModals() {
	const viewer = useViewer();

	return (
		<Switch>
			<Route<RouteProps>
				path={[
					'/users/:userID/conversations/create-from-moment/:momentID',
					'/users/:userID/conversations/create',
					'/conversations/create',
				]}
				exact
			>
				{({ match }) => (
					<CreateConversationModal
						userID={match!.params.userID! ?? viewer?.id}
						momentID={match!.params.momentID}
						returnURL={
							match!.params.momentID
								? `/manager`
								: `/users/${match!.params.userID ?? viewer?.id}/conversations`
						}
					/>
				)}
			</Route>
			<Route<RouteProps>
				path={['/users/:userID/conversations/request', '/conversations/request']}
				exact
			>
				{({ match }) => (
					<EvaluationSubmissionRequestModal
						userID={match!.params.userID! ?? viewer?.id}
						returnURL={`/users/${match!.params.userID ?? viewer?.id}/conversations`}
					/>
				)}
			</Route>
			<Route<RouteProps>
				path={[
					'/conversations/request-from-moment',
					'/users/:userID/conversations/request-from-moment',
				]}
				exact
			>
				{({ match }) => (
					<CycleMomentSelectorModal
						type={graphql.MomentType.Evaluation}
						regularURL={`/users/${match!.params.userID ?? viewer?.id}/conversations/request`}
						momentURL={(moment) =>
							`/users/${match!.params.userID ?? viewer?.id}/conversations/request-from-moment/${
								moment.id
							}`
						}
						returnURL={
							match?.params.userID
								? `/users/${match!.params.userID ?? viewer?.id}/conversations`
								: '/conversations'
						}
					/>
				)}
			</Route>
			<Route<RouteProps>
				path={[
					'/users/:userID/conversations/request-from-moment/:momentID',
					'/conversations/request-from-moment/:momentID',
				]}
				exact
			>
				{({ match }) => (
					<EvaluationSubmissionRequestModalMoment
						userID={match!.params.userID! ?? viewer?.id}
						returnURL={`/users/${match!.params.userID ?? viewer?.id}/conversations`}
					/>
				)}
			</Route>
		</Switch>
	);
}
